<script>
   /*************************************************************/
   /* Root component for the application                        */
   /*************************************************************/

   import AppContainer from './AppContainer.svelte';
</script>

<div class="page">

   <header>
      <div class="header-group">
         <img class="logo" alt="PCV logo" src="logo.svg" />
         <h1>Procrustes cross-validation (PCA based)</h1>
         <p>Create a validation set in your browser</p>
      </div>
   </header>

   <main>
      <AppContainer />
   </main>

   <footer>
      <p>More details: <a class="github-link" href="https://github.com/svkucheryavski/pcv/">svkucheryavski/pcv</a></p>
      <p>Theory and citation reference: <a class="paper-link" href="https://doi.org/10.1016/j.aca.2023.341096">10.1016/j.aca.2023.341096</a></p>
   </footer>
</div>

<style>
   .page {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;

      min-width: 1020px;
      min-height: 590px;

      display: flex;
      flex-direction: column;
   }

   .page > header{
      flex-basis: min-content;
      flex-shrink: 0;
      flex-grow: 0;
      text-align: center;
      background: #f8f6f4;
   }

   .header-group {
      width: max-content;
      margin: 0 auto;
      display: grid;
      align-items: center;
      grid-template-columns: min-content 1fr;
      grid-template-rows: min-content min-content min-content min-content;
      grid-template-areas:
         "logo ."
         "logo title"
         "logo subtitle"
         "logo .";
   }

   .logo{
      width: 5rem;
      margin: 0.25rem;
      grid-area: logo;
   }

   .header-group > h1{
      margin: 0;
      padding: 0;
      text-align: left;
      font-size: 1.6rem;
      color: #4e5052;
      white-space: nowrap;
      grid-area: title;
   }

   .header-group > p{
      margin: 0;
      padding: 0;
      text-align: left;
      font-size: 1.1rem;
      color: #7e8082;
      grid-area: subtitle;
   }

   .page > main{
      flex-basis: auto;
      flex-grow: 1;
      flex-shrink: 1;
      box-sizing: border-box;
      padding: 0.2rem 0rem;
   }

   .page > footer {
      font-size: 0.9rem;
      flex-basis: min-content;
      flex-grow: 0;
      flex-shrink: 0;
      background: #4e5052;
      color: #c0c0c0;
      padding: 0.5em;
   }

   .page > footer  p {
      max-width: 500px;
      text-align: center;
      margin: 0 auto;
      padding: 0.15em;
   }

   .page > footer  a {
      color: #f8ebc5
   }

   .page > footer  a.github-link {
      display: inline-block;
      padding-left: 1.3em;
      margin-left: 0.2em;
      background-size: 1em;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml;utf8,<svg width='98' height='96' fill='%23f8ebc5' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z'/></svg>");
   }
</style>